import { useCallback } from 'react';

interface ButtonProps {
  className?: string;
  children: string | React.ReactNode;
  primary?: boolean | null | undefined;
  secondary?: boolean | null | undefined;
  danger?: boolean | null | undefined;
  disabled?: boolean | null | undefined;
  type: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  small?: boolean | null | undefined;
  short?: boolean | null | undefined;
}

export default function Button({
  className,
  children,
  primary,
  secondary,
  danger,
  disabled,
  type = 'button',
  onClick,
  small,
  short,
  ...restProps
}: ButtonProps) {
  if (primary && secondary) {
    throw new Error('only one "primary" or "secondary" modifier is allowed');
  }

  const defaultClasses = `text-lg px-8 whitespace-nowrap ${
    small ? '' : 'min-w-52'
  } ${short ? 'py-0.5' : 'py-2'} rounded-full font-extrabold border-3 ${
    primary || secondary ? '' : 'border-black bg-gray-100'
  }`;
  let modifierClasses = '';

  if (primary) {
    modifierClasses =
      'bg-primary border-primary-dark hover:border-primary hover:text-gray-500';
  }

  if (secondary) {
    modifierClasses =
      'bg-white border-primary-dark text-primary-dark hover:bg-primary hover:bg-opacity-10';
  }

  if (disabled) {
    modifierClasses =
      'bg-gray-100 border-gray-300 text-gray-300 select-none cursor-default';
  }

  if (danger) {
    modifierClasses = 'bg-red-600 text-white border-red-700';
  }

  const handleClick = useCallback(
    () => !disabled && typeof onClick === 'function' && onClick(),
    [disabled, onClick]
  );

  return (
    <button
      className={`${
        className ? className : ''
      } ${modifierClasses} ${defaultClasses} ${
        disabled ? 'pointer-events-none' : ''
      }`}
      type={type}
      onClick={handleClick}
      {...restProps}
    >
      {children}
    </button>
  );
}
